import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {CardModel} from '../../../../models/api/cardModel';
import {VisualContactModel} from '../../../../models/api/visualContactModel';
import {
  contactCardAddCardToPrivateContactsAsyncAction,
  contactCardAddCardToSharedContactsAsyncAction,
} from '../../../../store/panels/contacts/contactCard/contactCardPanelActions';
import {ContactCardPanelId} from '../../../../store/panels/panelStateBase';
import {ContactCardFooterAddToContactsAction} from './contactCardFooterAddToContactsAction';

/*
 * Types.
 */

interface ContactCardFooterAddToContactsActionContainerProps {
  panelId: ContactCardPanelId;
  card?: CardModel;
  visualContact: VisualContactModel;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<ContactCardFooterAddToContactsActionContainerProps>()(
  ({panelId, card, visualContact}) => ({
    onAddToPrivateContactsAsync: () =>
      contactCardAddCardToPrivateContactsAsyncAction(panelId, visualContact, card),
    onAddToSharedContactsAsync: () =>
      contactCardAddCardToSharedContactsAsyncAction(panelId, visualContact, card),
  }),
);

export const ContactCardFooterAddToContactsActionContainer = connect(
  null,
  mapDispatchToProps,
)(ContactCardFooterAddToContactsAction);
